export default "__VITE_ASSET__DzSr8D82__"